import type { SelectOption, SelectedValue } from '../types';

export const isSelectOptionArray = (options: SelectedValue): options is SelectOption[] =>
	options != null && Array.isArray(options);
